import type { RecordUnion } from 'components/framework/models/generated/types';
import RecordAction from '../RecordAction';
import type ApplicationModel from 'components/framework/ApplicationModel';

export class LinkToRecordAction extends RecordAction<RecordUnion> {
  recordTypes = ['Epic', 'Feature', 'Requirement', 'Idea'];
  isRemoteLink = true;

  get title() {
    return 'Link to another record';
  }

  remoteLinkAttributes(records: RecordUnion[]) {
    const queryParams = new URLSearchParams({
      record_id: records[0].id,
      record_type: records[0].typename,
      'referrer_props[Trigger]': 'Right-click menu',
    });

    return {
      href: `/record_links/new?${queryParams}`,
    };
  }

  showForRecord(record: ApplicationModel): record is RecordUnion {
    return super.showForRecord(record) && this.selectedRecords.length === 1;
  }
}
